import React, { useContext } from 'react';

import { ButtonAnchor } from '@zooplus/ui-components';

import gradient from '../../common/assets/img/gradient.png';
import zooPoints from '../assets/img/zooPoints.svg';
import LocResourcesContext from '../contexts/LocResourcesContext';

const GLOBAL_PREFIX = 'loy-bppo-giftBanner-box';

interface GiftBannerProps {
  giftAmount: number;
  giftStatus: boolean;
  showRewardShopButton: boolean;
}

const GiftBanner = ({
  giftAmount,
  giftStatus,
  showRewardShopButton,
}: GiftBannerProps): JSX.Element => {
  const { onFormatLocale } = useContext(LocResourcesContext);
  const announcement =
    onFormatLocale?.('loy.bp.gift.announcement', {
      points: giftAmount,
    }) ?? '';

  const getGiftBannerWithoutPointsActive = () => {
    return (
      <div className={`${GLOBAL_PREFIX}-withoutPointsActive`}>
        <div className={`${GLOBAL_PREFIX}__points-withoutPointsActive`}
          dangerouslySetInnerHTML={{ __html: announcement }}></div>
        <div
          className={`${GLOBAL_PREFIX}__subtitle${(showRewardShopButton ? '--rws' : '--overview')}`}>
          {onFormatLocale?.('loy.bp.gift.announcement.subtitle')}
        </div>
        {showRewardShopButton && (
          <ButtonAnchor href="/account/bonuspoints/products/overview" className={`${GLOBAL_PREFIX}__button`}>
            {onFormatLocale?.('loy.rewardshop.link')}
          </ButtonAnchor>
        )}
        <div className={`${GLOBAL_PREFIX}__decoration`}>
          <img src={zooPoints} className={`${GLOBAL_PREFIX}__decoration--big-icon`}></img>
          <img src={zooPoints} className={`${GLOBAL_PREFIX}__decoration--small-icon`}></img>
          <img className={`${GLOBAL_PREFIX}__decoration--gradient`} src={gradient} />
        </div>
      </div>
    );
  };

  const getGiftBannerWithPointsActive = () => {
    return (
      <div className={`${GLOBAL_PREFIX}-withPointsActive`}>
        <div className={`${GLOBAL_PREFIX}__decoration`}>
          <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M3.75 24a2.25 2.25 0 01-2.25-2.25V12A1.5 1.5 0 010 10.5V8.25A2.25 2.25 0 012.25 6l4.452.001C4.952 4.748 3.75 2.835 3.75.75A.75.75 0 014.5 0l.235.004C8.228.119 11.501 2.769 11.948 6h.104c.457-3.303 3.868-6 7.448-6l.102.007a.75.75 0 01.648.743c0 2.085-1.201 3.998-2.952 5.251L21.75 6A2.25 2.25 0 0124 8.25v2.25a1.5 1.5 0 01-1.5 1.5v9.75A2.25 2.25 0 0120.25 24zM9 12H3v9.75c0 .414.336.75.75.75H9V12zm4.5 0h-3v10.5h3V12zm7.5 0h-6v10.5h5.25a.75.75 0 00.743-.648L21 21.75V12zM9 7.5H2.25a.75.75 0 00-.75.75v2.25H9v-3zm4.5 0h-3v3h3v-3zm8.25 0H15v3h7.5V8.25a.75.75 0 00-.75-.75zM5.335 1.56l.035.157c.52 2.1 2.66 3.876 5.045 4.222-.45-2.167-2.637-4.023-5.08-4.378zm13.33.002l-.035.004c-2.429.367-4.597 2.217-5.045 4.372 2.443-.354 4.63-2.21 5.08-4.376z"
              fillRule="evenodd"
            />
          </svg>
        </div>
        <div
          className={`${GLOBAL_PREFIX}__points-withPointsActive`}
          dangerouslySetInnerHTML={{ __html: announcement }}></div>
      </div>
    );
  };

  return giftStatus ? getGiftBannerWithPointsActive() : getGiftBannerWithoutPointsActive();
};

export default GiftBanner;
